import { Autocomplete, useLoadScript } from '@react-google-maps/api';
import { LanguageContext } from 'contexts/LanguageContext';
import { useContext, useRef, useState } from 'react';

const libraries = ['places'];

export function LocationSearch({ onSelect }) {
	const inputRef = useRef(null);
	const [autocomplete, setAutocomplete] = useState(null);
	const [value, setValue] = useState('');
	const { dictionary } = useContext(LanguageContext);

	const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

	const { isLoaded, loadError } = useLoadScript({
		googleMapsApiKey: apiKey,
		libraries,
	});

	if (!apiKey) return null;
	if (!isLoaded) return <div>{dictionary.loading_map}</div>;
	if (loadError) return <div>{dictionary.map_load_error || 'Failed to load map.'}</div>;

	const onLoad = (auto) => {
		setAutocomplete(auto);
	};

	const onPlaceChanged = () => {
		if (!autocomplete) return;

		const place = autocomplete.getPlace();
		if (!place.geometry || !place.geometry.location) return;

		const label = place.formatted_address || place.name || '';

		setValue(label);

		onSelect({
			latitude: place.geometry.location.lat(),
			longitude: place.geometry.location.lng(),
			name: place.name || '',
			address: place.formatted_address || '',
		});
	};

	const clearInput = () => {
		setValue('');
		onSelect(null);
		inputRef.current?.focus();
	};

	return (
		<div
			style={{
				position: 'relative',
				width: '100%',
			}}
		>
			<Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
				<input
					ref={inputRef}
					type="text"
					value={value}
					placeholder={dictionary.placeholder_search_address}
					onChange={(e) => setValue(e.target.value)}
					style={{
						width: '100%',
						padding: '10px 36px 10px 12px',
						borderRadius: 8,
						border: '1px solid #ccc',
						fontSize: 14,
						boxSizing: 'border-box',
					}}
				/>
			</Autocomplete>

			{value && (
				<button
					type="button"
					onClick={clearInput}
					style={{
						position: 'absolute',
						right: 10,
						top: '50%',
						transform: 'translateY(-50%)',
						border: 'none',
						background: 'transparent',
						cursor: 'pointer',
						fontSize: 16,
						lineHeight: 1,
						opacity: 0.6,
					}}
					aria-label="Clear address"
				>
					✕
				</button>
			)}
		</div>
	);
}
